import {
  Box,
  Flex,
  Grid,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { AdminIcon } from "../../_shared/AdminIcon";
import { AdminSidebar } from "../_shared/Sidebar";
import {
  useAdministratorsListQuery,
  useCreateAdministratorMutation,
} from "./index.generated";
import { BlueButton } from "~/routes/_shared/Buttons";
import { useEffect, useState } from "react";

export const AdminUser = () => {
  const [res] = useAdministratorsListQuery();

  if (res.fetching) return <Text>loading...</Text>;

  if (!res.data?.administrators) return null;
  const admins = res.data.administrators;
  return (
    <Flex>
      <AdminSidebar />
      <Box bgColor={"#16181a"} flexGrow={1} p={10}>
        <Flex
          flexDir="row"
          flexWrap="wrap"
          alignContent="center"
          justifyContent="space-between"
          py={2}
          my={4}
        >
          <Text fontSize={40} color="white" fontWeight={"bold"} mb={8}>
            管理者一覧
          </Text>
          <Flex gap={2} justifyItems="center">
            <CreateAdminModal />
          </Flex>
        </Flex>
        <Grid templateColumns="repeat(6, 1fr)" gap={8} mb={4}>
          {admins.map((admin) => {
            return <AdminIcon key={admin.id} admin={admin} />;
          })}
        </Grid>
      </Box>
    </Flex>
  );
};

const CreateAdminModal = ({}: {}) => {
  const [createAdminRes, createAdmin] = useCreateAdministratorMutation();

  const toast = useToast();
  const [name, setName] = useState("");
  const [isValidName, setIsValidName] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (name.length === 0) {
      setIsValidName(false);
    } else if (name.includes(" ")) {
      setIsValidName(false);
    } else if (name.includes("　")) {
      setIsValidName(false);
    } else {
      setIsValidName(true);
    }
  }, [name]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isOpenPasswordModal,
    onOpen: onOpenPasswordModal,
    onClose: onClosePasswordModal,
  } = useDisclosure();

  useEffect(() => {
    if (createAdminRes.data?.createAdministrator.password) {
      onOpenPasswordModal();
      setPassword(createAdminRes.data.createAdministrator.password);
    }
    if (createAdminRes.data?.createAdministrator.error) {
      toast({
        title: "管理者の作成に失敗しました。",
        description: createAdminRes.data.createAdministrator.error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [createAdminRes.data]);

  return (
    <>
      <BlueButton onClick={onOpen} label={"管理者を作成"} />
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>管理者を作成</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text pb={2} fontSize={20}>
              管理者を作成します。
            </Text>
            <Input
              placeholder={"名前"}
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Flex>
              <BlueButton
                isDisabled={!isValidName}
                onClick={() => {
                  createAdmin(
                    {
                      input: {
                        name,
                      },
                    },
                    { additionalTypenames: ["Administrator"] }
                  );
                  onClose();
                }}
                label={"作成"}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <ShowPasswordModal
        isOpen={isOpenPasswordModal}
        onClose={onClosePasswordModal}
        name={name}
        password={password}
      />
    </>
  );
};

const ShowPasswordModal = ({
  isOpen,
  onClose,
  name,
  password,
}: {
  isOpen: boolean;
  onClose: () => void;
  name: string | undefined;
  password: string | undefined;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={"xl"}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>ユーザーを作成しました。</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text pb={2} fontSize={20}>
            ユーザーを作成しました。
          </Text>
          <Text pb={2} fontSize={20} color="red.900">
            以下のパスワードは一度しか表示されません。
          </Text>
          <Text pb={2} fontSize={20}>
            必ずメモしてください。
          </Text>
          <Text pb={2} fontSize={20}>
            ユーザー名 : {name}
          </Text>
          <Text pb={2} fontSize={20}>
            パスワード : {password}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex>
            <BlueButton onClick={onClose} label={"ウィンドウを閉じる"} />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
